import { useUserRole } from 'hooks/useUser';
import type { ReactNode } from 'react';
import type { EUserType } from 'types/accessControll.types';

export const ShowIfUserIsInUserGroup = ({ group, children }: { group: EUserType[]; children: ReactNode }) => {
  const role = useUserRole();
  if (role && group.includes(role)) {
    return <>{children}</>;
  }
};
